// extracted by mini-css-extract-plugin
export default {"button":"LogoutButton_button__GhURS","buttonHover":"LogoutButton_buttonHover__o0LeX"};